import BaseHandler from "../BaseHandler";
import { ClientUnsubscribeFromRoom } from "../../proto/ClientUnsubscribeFromRoom_pb";
import store from "../../store";
import { removeRoom } from "../../store/rooms/actions";

export default class HandleClientUnsubscribeFromRoomResponse extends BaseHandler<ClientUnsubscribeFromRoom> {
  handle() {
    const currentRoom = store.getState().rooms.currentRoom;
    store.dispatch(removeRoom(currentRoom as string));
  }
}
